/** @jsxImportSource react */
import { IconName } from '@sly/icons/dist/icon.types';
import { getIcon } from '@sly/icons/dynamic';

export interface IconInfoTileIconProps {
  iconBorder: boolean;
  layout: 'iconTop' | 'default';
  icon: IconName;
}

export default function IconInfoTileIcon({
  iconBorder,
  layout,
  icon,
}: IconInfoTileIconProps) {
  // TODO move icon code into a separate component
  // as it shares with DynamicListWithIcons
  const marginBottom = layout === 'iconTop' ? 'mb-4' : '';
  const marginRight = iconBorder ? '' : 'mr-4';

  const Icon = getIcon(icon);

  return iconBorder ? (
    <div
      className={`self-start lg:mr-0 ${marginBottom} mr-4 rounded border border-slate-lighter-90 p-2`}
      data-tp-id='gen-div-ca5e13ec-660c-4eb7-8499-008eacf5d854'
    >
      <Icon className={`text-viridian-base ${marginRight} mr-0`} />
    </div>
  ) : (
    <Icon className={`text-viridian-base ${marginRight} mr-0`} />
  );
}
